export const m8l2Solution = `use option::OptionTrait;
use array::ArrayTrait;

#[derive(Drop)]
struct Student {
    name: felt252,
    courses: Array<Option<felt252>>,
}

fn display_grades(student: @Student, index: usize) -> felt252 {
    // don't mind these lines! They are required when
    // running recursive functions.
    match gas::withdraw_gas() {
        Option::Some(_) => {},
        Option::None(_) => {
            let mut data = ArrayTrait::new();
            data.append('Out of gas');
            panic(data);
        },
    }

    if index == 0_usize {
        let mut msg = ArrayTrait::new();
        msg.append(*student.name);
        msg.append('\\'s grades:');
        debug::print(msg);
    }
    if index >= student.courses.len() {
        return (0);
    }

    let course = *student.courses.at(index);

    // do not modify code on this line or above

    display_grades(student, index + 1_usize);

    if course.is_some() {
        return 'Grade';
    } else {
        return 'No grade';
    }
}

// do not modify code on this line or below

#[test]
#[available_gas(20000000)]
fn test_all_defined() {
    let mut courses = ArrayTrait::<Option<felt252>>::new();
    courses.append(Option::Some('A'));
    courses.append(Option::Some('B'));
    courses.append(Option::Some('C'));
    courses.append(Option::Some('A'));
    let mut student = Student { name: 'Alice', courses: courses };
    assert('Grade' == display_grades(@student, 0_usize), 'err1');
}


#[test]
#[available_gas(20000000)]
fn test_some_empty() {
    let mut courses = ArrayTrait::<Option<felt252>>::new();
    courses.append(Option::None(()));
    courses.append(Option::None(()));
    courses.append(Option::Some('B'));
    courses.append(Option::Some('C'));
    courses.append(Option::None(()));
    let mut student = Student { name: 'Bob', courses: courses };
    assert('No grade' == display_grades(@student, 0_usize), 'err2');
}`;
